import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsTaskSessionMessages = defineMessages(
  "panels-task-session",
  en,
);
